import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import Button from '../../ui/Button';
import ButtonGroup from '../../ui/ButtonGroup';

import TaraText from './TaraText';

const quantityOptions = [
  {
    label: 'any',
    value: 'any',
  },
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
  {
    label: '3',
    value: 3,
  },
  {
    label: '4+',
    value: 4,
  },
];

const Col = glamorous.div({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  animationDelay: '1600ms',
});

const styleDoubleSpaced = {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 32,
};

const noop = () => {};

class TaraQuestionQuantity extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: noop,
  };

  createHandleClick = (value) => (e) => {
    this.props.onClick(value);
  };

  render() {
    if (!this.props.persona) {
      return null;
    }

    const {
      isAnimated,
    } = this.props;

    return (
      <div style={styleDoubleSpaced}>
        <TaraText
          isQuestion
          isAnimated={isAnimated}
        >
          &hellip; and <strong>how many</strong> tickets do you need?
        </TaraText>
        <Col className={isAnimated ? 'animated fadeIn' : undefined}>
          <ButtonGroup>
            {quantityOptions.map(option => (
              <Button
                key={option.label}
                color="primary"
                label={option.label}
                onClick={this.createHandleClick(option.value)}
                isRaised={this.props.quantity === option.value}
                style={{
                  minHeight: 48,
                }}
              />
            ))}
          </ButtonGroup>
        </Col>
      </div>
    );
  }
}

export default TaraQuestionQuantity;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraQuestionQuantity.js